module.exports = __webpack_public_path__ + "assets/fa8147d8933b883b923ce03416a7b65b.mp3";